import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'dmv-pub-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MenuComponent {
}
